// extracted by mini-css-extract-plugin
export default {"icone_boost":"BoostedPost_icone_boost__upyL1","lien_utilisateur":"BoostedPost_lien_utilisateur__Fu2Hx","boutonCollab":"BoostedPost_boutonCollab__C5yFh"};